import {
  Modal as ChModal,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/modal";
import { FC } from "react";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  size?: 'sm' | 'md' | 'lg';
  title?: string;
}

export const Modal: FC<Props> = ({ isOpen, onClose, title = '', size="md", children }) => (
  <ChModal isOpen={isOpen} onClose={onClose} isCentered size={size}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader color={"brand.500"} pr={50}>{ title }</ModalHeader>
      <ModalCloseButton />
      { children }
    </ModalContent>
  </ChModal>
);
